// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    chain,
    ValidateEmail,
    ValidateFax,
    ValidatePhone,
    ValidatePostalCode,
} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { AddressFieldDisplayModel } from "@insite/client-framework/Types/ApiModels";
import { longZipCodePattern, shortZipCodePattern } from "@mcmc/App/Libraries/react-text-mask";
import { validators } from "@mcmc/Overrides/Widgets/CreateAccount/CreateAccount.form-helper";

type HandlerType = Parameters<typeof ValidatePostalCode>[0];

const isEmpty = (value: string) => value.trim().length <= 0;

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

export const CustomPostalValidatePostalCode = (props: HandlerType) => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { postalCode, country } = props.parameter.address;
    const invalidErrorMessage = validators.zipCode(postalCode, { country: country?.abbreviation });
    if (
        addressFieldDisplayCollection.postalCode?.isVisible &&
        validationRules.postalCode?.isRequired &&
        isEmpty(postalCode)
    ) {
        props.addressErrors.postalCode = getRequiredErrorMessage(addressFieldDisplayCollection.postalCode);
    } else if (addressFieldDisplayCollection.postalCode?.isVisible && !isEmpty(postalCode) && invalidErrorMessage) {
        props.addressErrors.postalCode = invalidErrorMessage;
    }
};

export const CustomValidatePhone: typeof ValidatePhone = props => {
    const { addressFieldDisplayCollection } = props.parameter;
    if (addressFieldDisplayCollection.phone?.isVisible) {
        return ValidatePhone(props);
    }
};

export const CustomValidateEmail: typeof ValidateEmail = props => {
    const { addressFieldDisplayCollection } = props.parameter;
    if (addressFieldDisplayCollection.email?.isVisible) {
        return ValidateEmail(props);
    }
};

export const CustomValidateFax: typeof ValidateFax = props => {
    const { addressFieldDisplayCollection } = props.parameter;
    if (addressFieldDisplayCollection.fax?.isVisible) {
        return ValidateFax(props);
    }
};

replaceInChain(chain, ValidatePostalCode, CustomPostalValidatePostalCode);
replaceInChain(chain, ValidatePhone, CustomValidatePhone);
replaceInChain(chain, ValidateEmail, CustomValidateEmail);
replaceInChain(chain, ValidateFax, CustomValidateFax);
